module.exports = __webpack_public_path__ + "img/002.c6871b67.png";